import { render, staticRenderFns } from "./PushPopup.vue?vue&type=template&id=17c33b54&"
import script from "./PushPopup.vue?vue&type=script&lang=ts&"
export * from "./PushPopup.vue?vue&type=script&lang=ts&"
import style0 from "./PushPopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports